import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/areaFinanciera/nominas';
import NominasList from './Nominas';

const ms2p = (state) => {
    return {
        ...state.nominas,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(NominasList);
